// Passion Program постер (Анар-Од-ийн design system загвар, 2026-10-30): арын зураг, лого + "Passion program" шошго, том гарчиг,
// тайлбар, багш/хамтрагчийн цагаан карт (шар сүүдэртэй), доор нил ягаан туузанд Хуваарь · Байршил.
// Хэмжээ нь өргөнөөсөө (container query) хамаарна — компьютер дээр 1080px загвартай ижил харьцаа, утсанд уншигдах доод хэмжээтэй.
import React, { useState } from "react";

export const API_ORIGIN = (process.env.REACT_APP_MAIN_API_URL || "").replace(/\/api\/?$/, "");
export const assetUrl = (p) => (!p ? null : /^https?:/.test(p) ? p : `${API_ORIGIN}${p}`);

const PURPLE = "#5c1090";
const YELLOW = "#f2cd30";
const fs = (min, px, max = px) => `clamp(${min}px, ${(px / 1080) * 100}cqw, ${max}px)`;

const Ico = ({ d, size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{d}</svg>
);
const CAL = <><path d="M8 2v4" /><path d="M16 2v4" /><rect width="18" height="18" x="3" y="4" rx="2" /><path d="M3 10h18" /></>;
const PIN = <><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" /><circle cx="12" cy="10" r="3" /></>;
const USER = <><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>;

const label = { fontSize: fs(10, 14), fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase" };

// Хуваарийн мөрүүд: ээлж 1 бол [дни, цаг]; олон бол "1-р бүлэг · Даваа, Лхагва" + цаг
export function scheduleRows(p) {
  const ss = (p.sessions || []).filter((s) => s.days);
  if (!ss.length) return [{ days: p.scheduleNote || "Эцэслэгдээд тавина", time: "" }];
  return ss.map((s) => ({ days: ss.length > 1 ? `${s.label} · ${s.days}` : s.days, time: s.time }));
}

// Тайлбар: "(…)" хэсэг налуу, энгийн жинтэй (дизайн: Changemakers)
function Desc({ text }) {
  return String(text).split(/(\([^)]*\))/).map((t, i) => (/^\(.*\)$/.test(t) ? <i key={i} style={{ fontWeight: "normal" }}>{t}</i> : t));
}

export default function Poster({ p }) {
  const cover = assetUrl(p.coverUrl);
  const photo = assetUrl(p.teacherPhotoUrl);
  const rows = scheduleRows(p);
  const dim = p.coverDim == null ? 0.35 : p.coverDim / 100;
  const partner = p.teacherLabel === "Хамтрагч"; // хамтрагч байгууллагын лого — дугуй биш, дөрвөлжин
  return (
    <div style={{ containerType: "inline-size" }} className="w-full">
      <div style={{ position: "relative", minHeight: "100cqw", overflow: "hidden", background: "#2a1245", color: "#fff", display: "flex", flexDirection: "column" }}>
        {cover && <img src={cover} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />}
        {dim > 0 && <div style={{ position: "absolute", inset: 0, background: `rgba(0, 0, 0, ${dim})` }} />}
        <div style={{ position: "relative", flex: 1, display: "flex", flexDirection: "column", padding: `${fs(18, 60)} ${fs(18, 72)} 0` }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
            <div style={{ background: "#fff", padding: `${fs(5, 12)} ${fs(7, 16)}`, display: "flex" }}>
              <img src="/tas-wordmark.png" alt="Tomujin Alternative School" style={{ height: fs(20, 48), width: "auto", display: "block" }} />
            </div>
            <div style={{ background: YELLOW, color: PURPLE, padding: `${fs(4, 10)} ${fs(8, 18)}`, fontSize: fs(10, 16), fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase", whiteSpace: "nowrap" }}>Passion program</div>
          </div>
          <h2 style={{ margin: `${fs(16, 52)} 0 0`, fontSize: fs(30, 116), fontWeight: 800, lineHeight: 0.98, letterSpacing: "-0.02em", textTransform: "uppercase", color: "#fff", textShadow: "0 2px 16px rgba(0,0,0,.35)", overflowWrap: "anywhere" }}>{p.name}</h2>
          {p.description && (
            <p style={{ margin: `${fs(10, 28)} 0 0`, fontSize: fs(14, 30), fontWeight: 600, lineHeight: 1.4, maxWidth: "82%", textShadow: "0 1px 10px rgba(0,0,0,.45)", whiteSpace: "pre-line" }}><Desc text={p.description} /></p>
          )}
          <div style={{ marginTop: "auto", paddingTop: fs(16, 32), marginBottom: fs(20, 56), alignSelf: "flex-start", maxWidth: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", gap: fs(10, 28), padding: `${fs(10, 24)} ${fs(14, 32)} ${fs(10, 24)} ${fs(10, 24)}`, background: "#fff", boxShadow: `${fs(4, 8)} ${fs(4, 8)} 0 0 ${YELLOW}` }}>
              {photo
                ? <img src={photo} alt={p.teacherName || ""} style={partner
                  ? { width: fs(52, 128), height: fs(52, 128), flexShrink: 0, borderRadius: 12, objectFit: "cover", display: "block" }
                  : { width: fs(52, 128), height: fs(52, 128), flexShrink: 0, borderRadius: 999, border: `3px solid ${PURPLE}`, objectFit: "cover", display: "block", background: "#fff" }} />
                : (
                  <div style={{ width: fs(52, 128), height: fs(52, 128), flexShrink: 0, borderRadius: 999, border: `3px solid ${PURPLE}`, background: "#f3eeff", color: PURPLE, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {p.teacherName ? <span style={{ fontSize: fs(8, 11), fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase" }}>Зураг</span> : <Ico d={USER} size={22} />}
                  </div>
                )}
              <div style={{ display: "flex", flexDirection: "column", gap: fs(2, 6), minWidth: 0 }}>
                <div style={{ ...label, color: PURPLE }}>{p.teacherLabel || "Багш"}</div>
                <div style={{ fontSize: fs(17, 36), fontWeight: 800, lineHeight: 1.1, color: "#1c1c1c" }}>{p.teacherName || "Удахгүй зарлана"}</div>
                {p.teacherBio && <div style={{ fontSize: fs(11.5, 20), fontWeight: 500, lineHeight: 1.4, color: "#6e5e8a", whiteSpace: "pre-line" }}>{p.teacherBio}</div>}
              </div>
            </div>
          </div>
        </div>
        <div style={{ position: "relative", background: PURPLE, padding: `${fs(16, 44)} ${fs(18, 72)} ${fs(18, 48)}`, display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: fs(14, 48) }}>
          {[["Хуваарь", CAL, rows], ["Байршил", PIN, [{ days: p.location || "Тодорхой болоогүй", time: "" }]]].map(([t, icon, rs]) => (
            <div key={t} style={{ display: "flex", alignItems: "flex-start", gap: fs(8, 20), minWidth: 0 }}>
              <div style={{ width: fs(30, 52), height: fs(30, 52), flexShrink: 0, borderRadius: 10, background: YELLOW, color: PURPLE, display: "flex", alignItems: "center", justifyContent: "center" }}><Ico d={icon} size={16} /></div>
              <div style={{ display: "flex", flexDirection: "column", gap: fs(2, 6), minWidth: 0 }}>
                <div style={{ ...label, color: YELLOW }}>{t}</div>
                {rs.map((r, i) => (
                  <React.Fragment key={i}>
                    <div style={{ fontSize: fs(13, 30), fontWeight: 700, lineHeight: 1.25 }}>{r.days}</div>
                    {r.time && <div style={{ fontSize: fs(13, 30), fontWeight: 700, lineHeight: 1.25, color: YELLOW }}>{r.time}</div>}
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Жагсаалтын жижиг постер (2 багана утсанд): зураг, нэр, хуваарь, төлөв
export function MiniPoster({ p, tag, onClick }) {
  const cover = assetUrl(p.coverUrl);
  const rows = scheduleRows(p);
  return (
    <button type="button" onClick={onClick} className={`relative w-full aspect-square overflow-hidden text-left cursor-pointer rounded-[14px] bg-[#2a1245] text-white ${p.mine ? "ring-[3px] ring-[#f2cd30]" : ""}`}>
      {cover && <img src={cover} alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />}
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,.15) 0%, rgba(0,0,0,.25) 40%, rgba(42,18,69,.92) 100%)" }} />
      <span className="absolute top-2 left-2 bg-[#f2cd30] text-primary text-[9px] font-extrabold tracking-[0.12em] uppercase px-1.5 py-0.5">Passion</span>
      {tag}
      <div className="absolute inset-x-0 bottom-0 p-2.5 md:p-3 flex flex-col gap-0.5">
        <b className="text-[15px] md:text-[18px] font-extrabold uppercase leading-[1.02] tracking-[-0.01em] [overflow-wrap:anywhere]" style={{ textShadow: "0 1px 8px rgba(0,0,0,.4)" }}>{p.name}</b>
        <span className="text-[11px] md:text-xs font-bold text-[#f2cd30] leading-tight">{rows.map((r) => [r.days, r.time].filter(Boolean).join(" · ")).join(" / ")}</span>
      </div>
    </button>
  );
}

// Долоо хоногийн хуваарь (дизайны "00 Долоо хоногийн хуваарь"): Даваа–Баасан, Өглөө / Үдээс хойш (12:00-аас), ээлжгүй хөтөлбөр доор
// "Цагийн хуваарь удахгүй". Хөтөлбөрийн өгөгдлөөс автоматаар — админ ээлж/цаг засахад шинэчлэгдэнэ. onOpen(p) — дарвал постер.
const WD = ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан"];
export function WeekPoster({ programs, onOpen }) {
  const items = [];
  (programs || []).forEach((p) => (p.sessions || []).forEach((s) => (s.slots || []).forEach((t) => {
    if (t.day >= 1 && t.day <= 5) {
      items.push({ p, day: t.day, start: String(t.startTime).slice(0, 5), end: String(t.endTime).slice(0, 5), group: p.sessions.length > 1 ? s.label : "" });
    }
  })));
  items.sort((a, b) => a.start.localeCompare(b.start) || (a.p.sortOrder || 0) - (b.p.sortOrder || 0));
  const later = (programs || []).filter((p) => !(p.sessions || []).some((s) => (s.slots || []).length));
  const part = (am) => WD.map((_, i) => items.filter((x) => x.day === i + 1 && (x.start < "12:00") === am));
  const pin = <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0, marginTop: 2 }}>{PIN}</svg>;
  const head = { gridColumn: "1 / -1", fontSize: fs(11, 14), fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: PURPLE };
  const box = { background: "#fff", border: `2px solid ${PURPLE}`, padding: `${fs(8, 12)} ${fs(9, 14)}`, display: "flex", flexDirection: "column", gap: 4, color: "#1c1c1c", textAlign: "left", cursor: onOpen ? "pointer" : "default", font: "inherit" };
  const Cell = ({ list }) => (!list.length ? <div style={{ border: "2px dashed #e5d8f5" }} /> : (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {list.map((x, i) => (
        <button key={i} type="button" onClick={() => onOpen && onOpen(x.p)} style={box}>
          <span style={{ fontSize: fs(13, 17), fontWeight: 800, lineHeight: 1.15, color: PURPLE }}>{x.p.shortName || x.p.name}</span>
          {x.group && <span style={{ fontSize: fs(10, 12), fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "#6e5e8a" }}>{x.group}</span>}
          <span style={{ fontSize: fs(13, 16), fontWeight: 700, lineHeight: 1.2 }}>{x.start}–{x.end}</span>
          {x.p.location && <span style={{ display: "flex", alignItems: "flex-start", gap: 5, fontSize: fs(11, 13), fontWeight: 600, lineHeight: 1.3, color: "#6e5e8a" }}>{pin}<span>{x.p.location}</span></span>}
        </button>
      ))}
    </div>
  ));
  return (
    <>
      <MobileWeek items={items} later={later} onOpen={onOpen} />
      <div className="hidden sm:block w-full">
      <div style={{ containerType: "inline-size" }}>
        <div style={{ minHeight: "100cqw", boxSizing: "border-box", background: "#fff", color: "#1c1c1c", padding: `${fs(24, 52)} ${fs(20, 56)} ${fs(20, 44)}`, display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex" }}><img src="/tas-wordmark.png" alt="Tomujin Alternative School" style={{ height: fs(30, 44), width: "auto", display: "block" }} /></div>
          <h2 style={{ margin: `${fs(16, 28)} 0 0`, fontSize: fs(26, 64), fontWeight: 800, lineHeight: 0.98, letterSpacing: "-0.02em", textTransform: "uppercase", color: PURPLE }}>Tomujin Passion Programs</h2>
          <div style={{ marginTop: fs(16, 26), display: "grid", gridTemplateColumns: "repeat(5, minmax(0, 1fr))", columnGap: 12, rowGap: 10 }}>
            {WD.map((d) => <div key={d} style={{ background: YELLOW, color: PURPLE, padding: "10px 8px", textAlign: "center", fontSize: fs(12, 16), fontWeight: 800, letterSpacing: "0.08em", textTransform: "uppercase" }}>{d}</div>)}
            <div style={{ ...head, marginTop: 4 }}>Өглөө</div>
            {part(true).map((l, i) => <Cell key={`a${i}`} list={l} />)}
            <div style={{ ...head, marginTop: 8 }}>Үдээс хойш</div>
            {part(false).map((l, i) => <Cell key={`p${i}`} list={l} />)}
          </div>
          {later.length > 0 && (
            <div style={{ marginTop: "auto", paddingTop: 20, display: "flex", flexDirection: "column", gap: 10 }}>
              <div style={head}>Цагийн хуваарь удахгүй</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 12 }}>
                {later.map((p) => (
                  <button key={p.id} type="button" onClick={() => onOpen && onOpen(p)} style={{ ...box, padding: `${fs(10, 14)} ${fs(12, 18)}` }}>
                    <span style={{ fontSize: fs(15, 20), fontWeight: 800, lineHeight: 1.15, color: PURPLE }}>{p.shortName || p.name}</span>
                    {p.location && <span style={{ display: "flex", alignItems: "center", gap: 6, fontSize: fs(12, 14), fontWeight: 600, lineHeight: 1.3, color: "#6e5e8a" }}>{pin}<span>{p.location}</span></span>}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      </div>
    </>
  );
}

// Утас (< 640px): дизайны өнгө, хэлбэрээр — өдрийн товч (өнөөдөр сонгогдсон), тэр өдрийн хөтөлбөрүүд нэг баганаар:
// зүүн талд цаг, баруун талд нэр · бүлэг · байршил; Өглөө / Үдээс хойш; доор нь цаг тодорхойгүй хөтөлбөрүүд.
function MobileWeek({ items, later, onOpen }) {
  const today = new Date().getDay();
  const [day, setDay] = useState(today >= 1 && today <= 5 ? today : 1);
  const list = items.filter((x) => x.day === day);
  const Row = ({ x }) => (
    <button type="button" onClick={() => onOpen && onOpen(x.p)} className="w-full flex items-stretch text-left bg-white cursor-pointer" style={{ border: `2px solid ${PURPLE}` }}>
      <span className="shrink-0 w-[68px] flex flex-col items-center justify-center py-2.5" style={{ background: "#f3eeff", color: PURPLE }}>
        <span className="text-[16px] font-extrabold leading-none tabular-nums">{x.start}</span>
        <span className="text-[11px] font-semibold leading-none mt-1.5 tabular-nums" style={{ color: "#6e5e8a" }}>{x.end}</span>
      </span>
      <span className="flex-1 min-w-0 flex flex-col justify-center gap-0.5 px-3 py-2.5">
        <span className="text-[15px] font-extrabold leading-tight truncate" style={{ color: PURPLE }}>{x.p.shortName || x.p.name}</span>
        {x.group && <span className="text-[10.5px] font-bold uppercase tracking-[0.06em]" style={{ color: "#6e5e8a" }}>{x.group}</span>}
        {x.p.location && <span className="text-[12px] font-semibold truncate" style={{ color: "#6e5e8a" }}>{x.p.location}</span>}
      </span>
    </button>
  );
  const Part = ({ title, rows }) => (rows.length ? (
    <div className="flex flex-col gap-2">
      <div className="text-[11px] font-bold uppercase tracking-[0.12em]" style={{ color: PURPLE }}>{title}</div>
      {rows.map((x, i) => <Row key={i} x={x} />)}
    </div>
  ) : null);
  return (
    <div className="sm:hidden bg-white p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between gap-3">
        <span className="text-[22px] font-extrabold uppercase leading-[0.98] tracking-[-0.02em]" style={{ color: PURPLE }}>Passion<br />Programs</span>
        <img src="/tas-wordmark.png" alt="Tomujin Alternative School" className="h-7 w-auto" />
      </div>
      <div className="grid grid-cols-5 gap-1.5" role="tablist">
        {WD.map((d, i) => {
          const on = day === i + 1;
          return (
            <button key={d} type="button" role="tab" aria-selected={on} aria-label={d} onClick={() => setDay(i + 1)} className="flex items-center justify-center h-11 cursor-pointer"
              style={{ background: on ? YELLOW : "#fff", color: PURPLE, border: `2px solid ${on ? YELLOW : "#e5d8f5"}` }}>
              <span className="text-[13px] font-extrabold uppercase tracking-[0.04em]">{d.slice(0, 2)}</span>
            </button>
          );
        })}
      </div>
      {list.length ? (
        <>
          <Part title="Өглөө" rows={list.filter((x) => x.start < "12:00")} />
          <Part title="Үдээс хойш" rows={list.filter((x) => x.start >= "12:00")} />
        </>
      ) : <div className="py-6 text-center text-[13px]" style={{ border: "2px dashed #e5d8f5", color: "#6e5e8a" }}>Энэ өдөр хөтөлбөр алга</div>}
      {later.length > 0 && (
        <div className="flex flex-col gap-2 pt-1">
          <div className="text-[11px] font-bold uppercase tracking-[0.12em]" style={{ color: PURPLE }}>Цагийн хуваарь удахгүй</div>
          <div className="grid grid-cols-2 gap-2">
            {later.map((p) => (
              <button key={p.id} type="button" onClick={() => onOpen && onOpen(p)} className="text-left bg-white px-3 py-2.5 flex flex-col gap-0.5 cursor-pointer" style={{ border: `2px solid ${PURPLE}` }}>
                <span className="text-[14px] font-extrabold leading-tight" style={{ color: PURPLE }}>{p.shortName || p.name}</span>
                {p.location && <span className="text-[11.5px] font-semibold leading-snug" style={{ color: "#6e5e8a" }}>{p.location}</span>}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
